import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getIcons } from "../Constant/Constant";
import { interestLevel } from "../../Enum";

const icons = getIcons();

const statusIcons = Object.freeze({
  Fresh: icons.freshIcon,
  "Registered Client": icons.registeredClient,
  "Follow-up": icons.interestedIcon,
  Dealing: icons.dealingIcon,
  "Deal Lost": icons.dealLostIcon,
  "Not Interested": icons.notInterestedIcon,
  Unanswered: icons.unansweredIcon,
  "Retry Suitable": icons.RetrySuitable,
});

const leadCharacterEmoji = Object.freeze({
  "Not Applicable": icons.NAEmoji,
  None: icons.NAEmoji,
  Excited: icons.excitedEmoji,
  Neutral: icons.neutralEmoji,
  Thinking: icons.ThinkingEmoji,
  Confused: icons.confusedEmoji,
});

const statusOptions = [
  "All",
  "Fresh",
  "Registered Client",
  "Follow-up",
  "Dealing",
  "Deal Lost",
  "Not Interested",
  "Unanswered",
  "Retry Suitable",
];

const AllLeadFilter = ({
  selectedTeam,
  totalLeadCount,
  nextPageToken,
  prevPageToken,
  currentPage,
  onPageChange,
  onStatusChange,
  selectedStatus,
  allLeadData,
  loading,
  emptyError =  "Select date, team, and user to view leads",
    displayStatus = false,
}) => {
  const [leads, setLeads] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [totalLead, setTotalLead] = useState(0);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;

  useEffect(() => {
    if (selectedTeam && Array.isArray(selectedTeam)) {
      const leadsArray = selectedTeam.map((lead) => {
        return {
          ...lead,
          id: lead.leadId,
          name: lead.leadName,
          assignedTeam: lead.teamName,
          assignedUser: lead.userName,
          docId: lead.leadId,
        };
      });

      setLeads(leadsArray);
      setFilteredLeads(leadsArray);
      setTotalLead(
        typeof totalLeadCount === "number" ? totalLeadCount : leadsArray.length
      );

      const currentDisplayCount = leadsArray.length;
      const startIndex = (currentPage - 1) * 10;
      setHasMoreLeads(startIndex + currentDisplayCount < totalLeadCount);
    } else {
      setLeads([]);
      setFilteredLeads([]);
      setTotalLead(0);
      setHasMoreLeads(false);
    }
  }, [selectedTeam, totalLeadCount, currentPage]);

  useEffect(() => {
    if (leads.length > 0 && searchKey) {
      const filtered = leads.filter((lead) =>
        lead.name.toLowerCase().includes(searchKey.toLowerCase())
      );
      setFilteredLeads(filtered);
    } else {
      setFilteredLeads(leads);
    }
  }, [searchKey, leads]);

  const handleSearchChange = () => {};

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchChange();
    }
  };

  const handleStatusFilterChange = (e) => {
    const status = e.target.value;
    if (onStatusChange) {
      onStatusChange(status);
    }
  };

  const handlePageChange = (token, direction) => {
    if (onPageChange) {
      onPageChange(token, direction);
    }
  };

  const noLeads = filteredLeads.length === 0;

  const calculateLastAct = (lastModifiedTime) => {
    const lastModifiedDate = new Date(lastModifiedTime);
    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate - lastModifiedDate);
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) - 1;
  };

  const getDaysStyle = (days) => {
    if (days < 5) {
      return "text-sky-500";
    } else if (days >= 5 && days <= 10) {
      return "text-yellow-500";
    } else {
      return "text-red-500";
    }
  };

  const formatDaysText = (days) => {
    return days <= 1 ? "Day" : "Days";
  };

  const navigate = useNavigate();

  const handleLeadInfo = (lead) => {
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.docId}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.docId}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.docId}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.docId}`;
    }
    navigate(path, { state: { lead , assignStatus : true} });
  };

  const getBackgroundClass = (label) => {
    switch (label) {
      case "Gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "Silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "Bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "Diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const shouldShowNextButton = nextPageToken && hasMoreLeads;

  return (
    <div className="h-[800px] w-full">
      <div className="flex justify-between flex-col gap-5">
        <div className="flex justify-between items-center px-3 ">
          <h1 className="text-3xl font-semibold 3xl:text-4xl ml-5">
            All Leads &#40;
            {totalLead !== undefined
              ? totalLead
              : searchKey !== null
              ? filteredLeads.length
              : 0}
            &#41;
          </h1>
          {/* <select
    value={selectedStatus}
    onChange={handleStatusFilterChange}
    className="w-40 border border-gray-300 rounded-md p-2"
  >
    {statusOptions.map(option => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select> */}
        </div>

        {displayStatus ? (
          ""
        ) : (
          <div className="flex items-center">
            <input
              className="border-customGreen rounded-md border bg-transparent w-[70%] h-10 px-4 mx-5 focus:outline-none"
              placeholder="Search by name or phone number"
              type="search"
              value={searchKey}
              onChange={(e) => setSearchKey(e.target.value.toLowerCase())}
              onKeyPress={handleSearchKeyPress}
            />
            <button
              className="w-[20%] p-2 text-white h-10 bg-customGreen rounded-md"
              onClick={handleSearchChange}
            >
              Search
            </button>
          </div>
        )}
      </div>

      <div className="overflow-y-auto custom-scrollbar h-3/4 bg-white py-5 px-5">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
          </div>
        ) : noLeads ? (
          <div className="text-center text-gray-500 py-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mx-auto text-gray-400 mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className="text-lg font-medium">No leads found</p>
            <p className="text-sm text-gray-500 mt-1">
              {emptyError}
            </p>
          </div>
        ) : (
          filteredLeads.map((lead) => (
            <div
              onClick={() => handleLeadInfo(lead)}
              key={lead.id}
              className="grid grid-cols-2 gap-4 px-10 py-2 xl:px-5 mt-5 rounded-lg shadow-md cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <div className="grid w-4/12 text-ellipsis xl:w-full">
                <h1
                  title={lead.name}
                  className="text-xl font-bold pt-3 text-ellipsis whitespace-nowrap xl:text-base 4xl:text-2xl truncate"
                >
                  {lead.name?.replace(/\b\w/g, (char) => char.toUpperCase())}
                </h1>

                <p className="font-medium">
                  Team:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedTeam}
                  </span>
                </p>
                <p className="font-medium">
                  Assigned User:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedUser}
                  </span>
                </p>
                <p className="font-medium flex items-center space-x-1">
                  <span>Locations:</span>
                  <span
                    title={lead.interestedLocations?.[0]}
                    className="font-medium 4xl:text-lg w-[95px] truncate overflow-hidden whitespace-nowrap"
                  >
                    {lead.interestedLocations?.[0] || "No Location"}
                  </span>
                  {lead.interestedLocations?.length > 1 && (
                    <span className="text-blue-500 font-semibold">
                      +{lead.interestedLocations.length - 1}
                    </span>
                  )}
                </p>

                {lead?.leadQuality ? (
                  <div className="flex items-center gap-2">
                    <img
                      src={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.image
                      }
                      alt={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.label
                      }
                    />
                    <div
                      className={`${getBackgroundClass(
                        lead?.leadQuality
                      )} font-semibold`}
                    >
                      {lead?.leadQuality === "None" ? "" : lead.leadQuality}
                    </div>
                  </div>
                ) : (
                  " "
                )}
              </div>

              <div className="grid grid-cols-3 gap-14 pt-4 4xl:text-lg xl:text-sm">
                <div className="flex flex-col items-center w-auto pt-2 justify-center">
                  <img
                    className="xl:w-12 4xl:w-12"
                    src={statusIcons[lead.status]}
                    alt={lead.status}
                  />
                  <p className="font-medium whitespace-nowrap truncate">
                    {lead.status}
                  </p>
                </div>

                <div className="flex flex-col items-center w-auto justify-center">
                  <div className="">
                    <span
                      className={`text-2xl mr-1 4xl:text-5xl ${getDaysStyle(
                        calculateLastAct(lead.lastModifiedTime)
                      )}`}
                    >
                      {calculateLastAct(lead.lastModifiedTime)}
                    </span>
                    <span className="text-base text-gray-500">
                      {formatDaysText(calculateLastAct(lead.lastModifiedTime))}
                    </span>
                  </div>
                  <p className="whitespace-nowrap">Last act</p>
                </div>

                <div className="flex flex-col items-center w-auto pt-2 justify-center">
                  <img
                    className="xl:w-8 4xl:w-12"
                    src={leadCharacterEmoji[lead.leadCharacter]}
                    alt={lead.leadCharacter}
                  />
                  <p className="">Type</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="flex justify-center my-5 gap-10">
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange(prevPageToken, "previous")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img
              src={icons.previousPagination}
              className="w-3"
              alt="Previous"
            />
          </button>
        )}
        <span>{currentPage}</span>
        {shouldShowNextButton && (
          <button
            onClick={() => handlePageChange(nextPageToken, "next")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img src={icons.nextPagination} className="w-3" alt="Next" />
          </button>
        )}
      </div>
    </div>
  );
};

export default AllLeadFilter;
